import script from "./SearchHistoryDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchHistoryDialog.vue?vue&type=script&setup=true&lang=js"

import "./SearchHistoryDialog.vue?vue&type=style&index=0&id=1a3ecb56&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a3ecb56"]])

export default __exports__